import { format } from 'date-fns';

export const formatterDataToCardInfo = (campaigns: any) => {
	if (campaigns.length) {
		return campaigns
			.sort(
				(objA: any, objB: any) =>
					Number(new Date(objB.createdAt)) - Number(new Date(objA.createdAt)),
			)
			.map((campaign: any) => {
				const formatedStartDate = campaign.createdAt
					? `${format(
							new Date(`${campaign.createdAt.split('T').shift()} 12:00:00`),
							'dd/MM/yyyy',
					  )}`
					: null;

				return {
					id: campaign.id,
					title: `Campaña ${campaign.type} ${new Date(
						campaign.createdAt,
					).getFullYear()}`,
					companyName: campaign.name,
					date: formatedStartDate,
					iconType: campaign.status === 'active' ? 'edit' : 'calendar',
					disabled: campaign.status === 'active' ? false : true,
				};
			});
	}

	return [];
};
